import React, { useContext, useState, useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useNavigationHistory } from 'Navigation/NavigationHistoryProvider';
import { HubContext } from 'Redux/Context/context';
import { toggleGlobalModalAction, manuallySentEmailIncrementAction } from 'Redux/Actions/actions';
import { _fetch } from 'Chore/Request';
import { generateExcel } from 'Chore/Utils';
import Avatar from 'Components/Avatar';
import { ACTIVITY_STATUS, PAGINATION_OPTIONS, PUBLISHER_CATEGORY, ROUTES_PATH } from 'Chore/Constants';
import { PATH } from 'Chore/Apis';
import {
  VegaFlex,
  VegaButtonLink,
  VegaDivider,
  VegaTable,
  VegaPagination,
  VegaBox,
} from '@heartlandone/vega-react';
import { VegaNotify } from '@heartlandone/vega';
import DeleteRegisterModal from '../../Components/DeleteRegisterModal/DeleteRegisterModal';
import SendEmailNotificationPopup from '../../Components/SendEmailNotificationPopup/SendEmailNotificationPopup';
import ActivityState from './ActivityInformations/State';
import ActivityCategory from './ActivityInformations/Category';
import ActivityCharge from './ActivityInformations/Charge';
import CancelActivityAction from './ActivityActions/CancelActivity';
import ActivityAddress from './ActivityInformations/Address';
import ActivityTimeRange from './ActivityInformations/TimeRange';
import ActivityTitle from './ActivityInformations/Title';
import EditActivityAction from './ActivityActions/EditActivity';
function ViewMyPublishedActivityDetail() {
  const { globalModalDispatch, dashboardBasicDataState, myActivitiesState, manuallySentEmailState, manuallySentEmailDispatch, userInfoState } = useContext(HubContext);
  const params = useLoaderData();
  const navigate = useNavigate();
  const { goBack } = useNavigationHistory();
  const [total, setTotal] = useState(0);
  const [activity, setActivity] = useState({});
  const [registers, setRegisters] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  // Using built-in VegaTable rowExpandable behavior
  const [deleteModalState, setDeleteModalState] = useState({ open: false, register: null });
  const emailNotificationSentCount = activity?.emailNotificationSentCount || 0;
  const routeActivityId = params?.id;
  const sentCount = manuallySentEmailState?.[activity?.id || routeActivityId] || emailNotificationSentCount;
  const maxEmailSends = 3;
  const { GET_ACTIVITY, GET_ALL_REGISTERS, DELETE_REGISTER } = PATH;
  const { ACTIVITY_GUEST_LIST } = PAGINATION_OPTIONS;

  useEffect(() => {
  const { id } = params || {};
  if(!id) return;
  getCurrentActivity(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myActivitiesState]);

  useEffect(() => {
    const { id } = params;
    _loadActivityRegistersInfo({id})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCurrentActivity = (id) => {
    const found = (myActivitiesState?.activities ?? []).find((a) => `${a.id}` === `${id}`);
    if(found){
      setActivity(found);
      return;
    }
    _fetch({ api: `${GET_ACTIVITY}/${id}` })
    .then(res => {
      if(res?.code === 2200){
        setActivity(res?.payload || {});
      }
    });
  }

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  const _loadActivityRegistersInfo = ({
    id,
    pageindex = 1,
    pagesize = ACTIVITY_GUEST_LIST.SPAN
  }) => {
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITY}/${id}/registers?pageindex=${pageindex}&pagesize=${pagesize}`,
    }).then((res) => {
      setRegisters(res?.payload?.items);
      const timer = setTimeout(() => {
        setTotal(res?.payload?.totalCount);
        clearTimeout(timer);
      }, 200);
    }).finally(() => {
      _toggleModal();
    })
  }

  const _onPageIndexClick = (e) => {
    const { id } = params;
    const next = e.detail;
    setPageIndex(next);
    _loadActivityRegistersInfo({
      id,
      pageindex: next,
      pagesize: ACTIVITY_GUEST_LIST.SPAN
    });
  }

  const widths = ['10.3455%','10.3455%','11.2855%','12.2275%','12.2275%','18.8105%', '18.812%'];

  const currentUser = userInfoState?.userInfo;
  const permissions = dashboardBasicDataState?.permissions || [];
  const isAdmin = Array.isArray(permissions) && permissions.includes('Module.ActivityHub.CompanyActivity.Create');
  const isOwner = (!!activity?.createdUserId && !!currentUser?.userId && activity.createdUserId === currentUser.userId);
  const renderExpandContent = (guest, { widths }) => {
    const cellStyle = (w) => ({ width: w, padding: '12px', boxSizing: 'border-box' });
    return (
      <VegaFlex alignItems="center" className="f-size-14">
        <div style={cellStyle(widths[0])}>{guest.name}</div>
        <div style={cellStyle(widths[1])}>{guest.nativeName}</div>
        <div style={cellStyle(widths[2])}>{guest.location}</div>
        <div style={cellStyle(widths[3])}>{guest.allocation}</div>
        <div style={cellStyle(widths[4])}>{guest.phone}</div>
        <div style={cellStyle(widths[5])}>{guest.email}</div>
        <div style={cellStyle(widths[6])}>{guest.note}</div>
      </VegaFlex>
    );
  };

  const _onExportFormClick = () => {
    const { id } = params;
    _fetch({
      method: 'GET',
      api: GET_ALL_REGISTERS(id),
    }).then(res => {
      const registers = res?.payload?.items;
      generateExcel(registers, {
        fileName: `${activity?.title}-registers`,
        columns: [
          { header: "Name", key: 'name', width: 20 },
          { header: "Native Name", key: 'nativeName', width: 20 },
          { header: "Location", key: 'location', width: 20 },
          { header: "Allocation", key: 'allocation', width: 20 },
          { header: "Phone Number", key: 'phone', width: 20 },
          { header: "Email", key: 'email', width: 40 },
          { header: "Note", key: 'note', width: 40 },
        ],
        expandRow: 'guests',
      });
    });
  }
  const { id: activityId, isOnlineActivity, city, address, startTime, endTime, activityStatus, title } = activity || {};

  const _onViewDetialClick = () => {
    if(!activityId) return;
    navigate(`${ROUTES_PATH.ACTIVITY_INFO}/${activityId}`);
  }
  const _showSendEmailNotificationBtn = () => {
    return (
      activity?.publisherCategory !== PUBLISHER_CATEGORY.PERSONAL
    );
  }

  const _onEditSendEmailNotificationClick = () => {
    setShowEmailPopup(true);
  }
  const { STATUS_LABEL } = ACTIVITY_STATUS;
  const _isNotClosedStatus = () => {
    return activity?.activityStatus !== STATUS_LABEL.CLOSED
  }
  const _isCancelActivityAction = () => {
    const currentUTCTime = new Date().getTime();
    const targetUTCTime = new Date(activity.startTime).getTime();
    return (
        targetUTCTime > currentUTCTime &&
        activity?.status !== STATUS_LABEL.CLOSED
    );
  }
  const _isEditActivityAction = () => {
    const currentUTCTime = new Date().getTime();
    const targetUTCTime = new Date(activity.startTime).getTime();
    return (
        targetUTCTime > currentUTCTime &&
        activity?.status !== STATUS_LABEL.CLOSED
    );
  }
  const _showCategory = () => {
    if (activity?.publisherCategory === null || activity?.publisherCategory === "" || activity?.publisherCategory === undefined) {
      return false;
    }
    return true;
  }
  const reGetActivity = () => {
    if(!activityId) return;
    _fetch({ api: `${GET_ACTIVITY}/${activityId}` })
      .then(res => {
        if(res.code === 2200){
          const nextActivity = res?.payload;
          setActivity(nextActivity);
        }
      }).finally(() => {
        _isCancelActivityAction();
        _isEditActivityAction();
      });
  }

  const _deleteRegisterConfirm = (register) => {
    setDeleteModalState({ open: true, register });
  };

  const _deleteRegister = (registerId) => {
    const { id } = params;
    _fetch({
      api: `${DELETE_REGISTER(registerId)}`,
      method: 'DELETE'
    })
    .then(res => {
      if(res.code === 2200){
        VegaNotify.open({
          type: 'success',
          message: 'The participant has been removed.'
        });
        // reload current page data after deletion
        _loadActivityRegistersInfo({ id, pageindex: pageIndex });
      } else {
        VegaNotify.open({
          type: 'error',
          message: 'The participant could not be removed.'
        });
      }
    })
  }

  return (
    <VegaFlex direction="col" gap="size-24" style={{ width: '100%' }} className="m-t-24 m-b-24">
      <VegaFlex>
        <VegaButtonLink label="Back" icon="fa-solid fa-angle-left" onVegaClick={() => goBack('/my-activity?category=Published')} />
      </VegaFlex>
      <VegaFlex direction={'col'} gap={'size-12'}>
        <ActivityTitle state={activityStatus} title={title} />
        <VegaFlex alignItems={'center'}>
          <VegaFlex gap={'size-8'} alignItems={'center'}>
            <Avatar width="size-20" name={activity?.createdBy} avatarUrl={activity?.createdByAvatarUrl === null ? '' : activity?.createdByAvatarUrl} />
            <span className="m-0 p-r-16 b-r-1">{activity?.createdBy}</span>
          </VegaFlex>
          <div className={'p-r-16 p-l-16 b-r-1 font-light-text-color-secondary'}>
            <ActivityTimeRange startTime={startTime} endTime={endTime} />
          </div>
          <div className={'p-r-16 p-l-16 b-r-1 font-light-text-color-secondary max-width-25'}>
            <ActivityAddress online={isOnlineActivity} address={address} city={city} />
          </div>
          <div className={'p-r-16 p-l-16 font-light-text-color-primary'}>
            <VegaFlex className="display-flex" gap="size-8">
              <VegaBox flexShrink="0">
                <ActivityState state={activity?.activityStatus} />
              </VegaBox>
              {_showCategory() && <ActivityCategory category={activity?.publisherCategory} />}
              {_isNotClosedStatus() && <ActivityCharge chargeAmount={activity?.chargeAmount} />}
            </VegaFlex>
          </div>
        </VegaFlex>
        <VegaFlex className={'action-button'} gap={'size-12'}>
          {[
            <VegaButtonLink
              key="view"
              label="View Activity Details"
              icon="fa-regular fa-eye"
              onVegaClick={_onViewDetialClick}
            />,
            (isOwner && _isEditActivityAction()) && <EditActivityAction key="edit" activity={activity} />,
            (isOwner && _showSendEmailNotificationBtn()) && (
              <VegaButtonLink
                key="email"
                label={`Send Email Notification (${sentCount}/${maxEmailSends})`}
                icon="fa-regular fa-envelope"
                onVegaClick={_onEditSendEmailNotificationClick}
                disabled={sentCount >= maxEmailSends}
              />
            ),
            (isOwner && _isCancelActivityAction()) && <CancelActivityAction key="cancel" activity={activity} callback={reGetActivity} />,
          ]
            .filter(Boolean)
            .map((button, index) => (
              <React.Fragment key={index}>
                {!!index && (
                  <VegaBox height="size-24">
                    <VegaDivider direction="vertical" />
                  </VegaBox>
                )}
                {button}
              </React.Fragment>
            ))}
        </VegaFlex>
        <VegaDivider />
        <VegaFlex direction={'col'}>
          <VegaFlex justifyContent={'space-between'} alignItems={'center'}>
            <h2>Participants</h2>
            <VegaButtonLink label="Excel" icon="fa-solid fa-arrow-down-to-line" onVegaClick={_onExportFormClick} />
          </VegaFlex>
                   <VegaTable
            columns={[
              { label: 'Name', prop: 'name', overflow: 'ellipsis', width: '11%' },
              { label: 'Native Name', prop: 'nativeName', overflow: 'ellipsis', width: '11%' },
              { label: 'Location', prop: 'location', overflow: 'ellipsis', width: '12%' },
              { label: 'Allocation', prop: 'allocation', overflow: 'ellipsis', width: '13%' },
              { label: 'Phone Number', prop: 'phone', overflow: 'ellipsis', width: '13%' },
              { label: 'Email', prop: 'email', overflow: 'ellipsis', width: '20%' },
              { label: 'Note', prop: 'note', overflow: 'ellipsis', width: '20%' },
              ...((isOwner || isAdmin)
                ? [
                    {
                      width: '40px',
                      render: (createElement, _, record) => {
                        return createElement('vega-button-link', {
                          key: 'del',
                          size: 'size-16',
                          icon: 'fa-regular fa-trash-can',
                          onVegaClick: () => _deleteRegisterConfirm(record),
                        });
                      },
                    },
                  ]
                : []),
            ]}
            rowExpandable={true}
            dataSource={registers}
            rowKey="registerId"
          >
            {registers.map((register, i) =>
              register.guests.map((guest) => (
                <div
                  key={register.registerId}
                  slot={`vega-table-expand-row-${register.registerId}`}
                >
                  {renderExpandContent(guest, { widths }, i)}
                </div>
              ))
            )}
          </VegaTable>
        </VegaFlex>
        <VegaFlex className={'m-t-16'} justifyContent="end">
          <VegaPagination
            total={total}
            pageSize={ACTIVITY_GUEST_LIST.SPAN}
            current={pageIndex}
            extensions={[["currentPageLabel", "pageSelector"]]}
            onVegaChange={_onPageIndexClick}
          />
        </VegaFlex>
      </VegaFlex>
      <SendEmailNotificationPopup
        isOpen={showEmailPopup}
        onClose={() => setShowEmailPopup(false)}
        onSended={(status) => {
          if (status === 'success' && activityId) {
            manuallySentEmailDispatch(manuallySentEmailIncrementAction(activityId));
          }
        }}
        activityId={activityId || routeActivityId}
        sentCount={sentCount}
        maxCount={maxEmailSends}
      />
      <DeleteRegisterModal
        open={deleteModalState.open}
        register={deleteModalState.register}
        onConfirm={(reg) => _deleteRegister(reg.registerId)}
        onClose={() => setDeleteModalState({ open: false, register: null })}
      />
    </VegaFlex>
  );
}

export default ViewMyPublishedActivityDetail;
